// Roles allowed to create, edit, delete and assign formations & briefs, and to manage their
// resources. Mirrors Formation::MANAGER_ROLES on the backend — keep the two lists in sync.
// What each role may assign *to*, and which formations it sees, is narrowed server-side
// (chef_terrain -> superviseurs / F2F surveys, resp_cati -> enquêteurs CATI / CATI surveys).
export const FORMATION_MANAGER_ROLES = [
  'charge_etude',
  'charge_etude_superieur',
  'administrateur_general',
  'administrateur_general_superieur',
  'chef_terrain',
  'chef_terrain_superieur',
  'resp_controle',
  'resp_cati',
];
